module.exports = __webpack_public_path__ + "img/logo2.93c9b12c.png";